import { useEffect } from 'react';
import { Link, useHistory, useRouteMatch, Switch } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Col, Menu, Row, Space } from 'antd';

import CustomRoute from '@/components/_common/CustomRoute';
import ContentWrapper from '@/components/_common/ContentWrapper';

import './style.less';
import { PageProps } from '@/types/PageProps';
import { useWindowSize } from '@/hooks';
import { DownOutlined } from '@ant-design/icons';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import AccessDenied from '@/components/_common/AccessDenied';

const ConfigsProfilePage = ({ route }: PageProps) => {
  const history = useHistory();
  const match = useRouteMatch();
  const { isMobile } = useWindowSize();

  useEffect(() => {
    if (match.isExact) {
      history.push(`/app/configProfile/account`);
    }
  }, []);

  const historyKeys = history?.location?.pathname?.split('/');
  const settingsKeyIndex = historyKeys.indexOf('configProfile');
  const selectedMenuKey = historyKeys[settingsKeyIndex + 1];

  return (
    <ContentWrapper>
      <Row className="settings-wrapper">
        <Col span={24} md={11} lg={7}>
          <Menu
            mode={isMobile ? 'horizontal' : 'inline'}
            className="menu"
            selectedKeys={[selectedMenuKey]}
            overflowedIndicator={
              <Space>
                Abrir Navegação <DownOutlined style={{ fontSize: '10px' }} />
              </Space>
            }
          >
            {route.routes
              .filter((r) => hasPermissions(r.permissions || []))
              .map((r) => (
                <Menu.Item key={r.key}>
                  <Link to={r.path}>
                    <FormattedMessage id={r.name} />
                  </Link>
                </Menu.Item>
              ))}
          </Menu>
        </Col>

        <Col span={24} md={13} lg={17}>
          {route.routes.map((r) => (
            <div key={r.key}>
              <CustomRoute
                {...r}
                component={
                  hasPermissions(r.permissions || [])
                    ? r.component
                    : AccessDenied
                }
              />
              {hasPermissions(r.permissions || []) && (
                <Switch>
                  {r.routes?.map((iR) => (
                    <CustomRoute
                      {...iR}
                      component={
                        hasPermissions(r.permissions || [])
                          ? r.component
                          : AccessDenied
                      }
                    />
                  ))}
                </Switch>
              )}
            </div>
          ))}
        </Col>
      </Row>
    </ContentWrapper>
  );
};

export default ConfigsProfilePage;
